<template>
  <div v-if="showListUsers">
    <User :data="usersList" :columns="columns">
      <td slot="actions" slot-scope="item" class="acciones">
        <b-button
          :disabled="!posibleEditar(item.item)"
          @click="addUserPerms(item.item)"
          class="actions-btn add"
          v-b-tooltip.hover.left
          title="Gestionar Accesos a Módulos"
          >+</b-button
        >
        <b-button
          :disabled="!posibleEliminar(item.item)"
          @click="removeUserService(item.item)"
          class="actions-btn remove"
          v-b-tooltip.hover.left
          title="Eliminar Usuario de Este Servicio"
          ><i class="bx bx-trash"></i
        ></b-button>
        <!-- <Roles /> -->
      </td>
      <td slot="adminActions" slot-scope="item" class="acciones">
        <b-button
          @click="agregarServicioSuperAdmin(item.item)"
          class="actions-btn add"
          v-b-tooltip.hover.left
          title="Añadir un Servicio"
          >+</b-button
        >
        <b-button
          @click="editarAccesos(item.item)"
          class="actions-btn edit"
          v-b-tooltip.hover.left
          title="Editar Accessos"
          ><i class="bx bx-edit-alt"></i
        ></b-button>
        <b-button
          @click="eliminarUsuarioSuperAdmin(item.item)"
          class="actions-btn remove"
          v-b-tooltip.hover.left
          title="Eliminar Usuario"
          ><i class="bx bx-trash"></i
        ></b-button>

        <!-- <Roles /> -->
      </td>
    </User>
    <b-modal v-model="showPermsModal" hide-header hide-footer>
      <AddPerms
        :datosUsuario="selectedUser"
        :closeModal="closeModal"
        :getUsers="getUsers"
      />
    </b-modal>
    <b-modal v-model="showServiceModal" hide-header hide-footer>
      <AddService
        :datosUsuario="selectedUser"
        :profileOptions="sendProfileOptions"
        :listServices="listServices"
        :closeModal="closeModal"
        :getUsers="getUsers"
        :ministerList="ministerList"
      />
    </b-modal>
    <b-modal v-model="showEditServicesModal" hide-header hide-footer>
      <EditServices
        :datosUsuario="selectedUser"
        :closeModal="closeModal"
        :profileOptions="sendProfileOptions"
      />
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import User from "../../../../components/tables/User.vue";
import AddPerms from "./AddPerms.vue";
import AddService from "./AddService.vue";
import EditServices from "./EditServices.vue";
import {
  possibleRoles,
  hierarchyRole,
  hierarchyRoleEdit,
} from "../../../../components/tools/utils";
import { showAlert } from "../../../../components/tools/utils";
import Swal from "sweetalert2";
export default {
  components: {
    User,
    AddPerms,
    AddService,
    EditServices,
  },
  data() {
    return {
      usersList: [],
      showListUsers: true,
      selectedUser: null,
      showPermsModal: false,
      showServiceModal: false,
      showEditServicesModal: false,
      listServices: null,
      sendProfileOptions: null,
      profileOptions: [
        { value: null, text: "- Seleccionar Perfil -" },
        { value: 5, text: "Funcionario" },
        { value: 4, text: "Encargado BGI" },
        { value: 3, text: "Jefe de Servicio" },
        { value: 6, text: "Representante Ministerial" },
        { value: 2, text: "Administrador de la DIPRES" },
        { value: 1, text: "Super Adminstrador", disabled: true },
      ],
    };
  },
  props: ["data", "columns", "getUsers", "ministerList"],
  computed: {
    ...mapState("items", ["items"]),
    ...mapState("sesion", ["usuario", "relacionUS"]),
  },
  methods: {
    addUserPerms: function(obj) {
      this.showPermsModal = true;
      this.selectedUser = obj;
    },
    removeUserService: async function(obj) {
      const { idServicio } = this.$route.params;
      const { id } = obj;
      const token = localStorage.getItem("userToken");
      const options = {
        headers: {
          Authorization: `JWT ${token}`,
        },
      };

      Swal.fire({
        title: "Está seguro de realizar esta acción?",
        text: "Esta acción es Irreversible",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const relacion = await axios.get(
              `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/${id}/`,
              options
            );

            const { usuarioServicioId } = relacion.data.servicios.find(
              (s) => s.id === idServicio
            );

            await axios.delete(
              `${process.env.VUE_APP_RUTA_API}/instituciones/usuarioservicio/${usuarioServicioId}/`,
              options
            );
            this.getUsers();
            Swal.fire(
              "Eliminado!",
              "Usuario eliminado de este servicio",
              "success"
            );
          } catch (error) {
            console.log(error);
            showAlert({
              icon: "error",
              text: error.response.data[Object.keys(error.response.data)[0]],
              timerProgressBar: true,
              timer: 3000,
            });
          }
        }
      });
    },
    editarAccesos: async function(obj) {
      this.selectedUser = obj;
      this.showEditServicesModal = true;
      // console.log(obj);
    },
    posibleEditar: function(obj) {
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN)
        return true;
      if (hierarchyRoleEdit(this.relacionUS.rolId).includes(obj.rol.id)) {
        return true;
      } else {
        return false;
      }
    },
    posibleEliminar: function(obj) {
      if (
        hierarchyRole(
          this.usuario.username === process.env.VUE_APP_USER_ADMIN
            ? 1
            : this.relacionUS.rolId
        ).includes(obj.rol.id)
      ) {
        return true;
      } else {
        return false;
      }
    },
    agregarServicioSuperAdmin: async function(obj) {
      this.selectedUser = obj;
      this.showServiceModal = true;
      this.serviceListSuperAdmin();
      this.profileListSuperAdmin();
    },
    eliminarUsuarioSuperAdmin: async function(user) {
      const { id } = user;
      const token = localStorage.getItem("userToken");
      const options = {
        headers: {
          Authorization: `JWT ${token}`,
        },
      };
      Swal.fire({
        title: "Está seguro de realizar esta acción?",
        text: "Esta acción es Irreversible",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.delete(
              `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/${id}/`,
              options
            );
            showAlert({
              icon: "success",
              text: "Usuario eliminado con éxito.",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            showAlert({
              icon: "error",
              text: error.response.data[Object.keys(error.response.data)[0]],
              timerProgressBar: true,
              timer: 3000,
            });
          }
          this.getUsers();
        }
      });
    },
    profileListSuperAdmin: function() {
      this.sendProfileOptions = this.profileOptions;
    },
    profileList: function() {
      this.sendProfileOptions = this.profileOptions.filter((p) =>
        possibleRoles(this.relacionUS.rolId).includes(p.value)
      );
      this.sendProfileOptions.unshift({
        value: null,
        text: "- Selecciona una opción -",
      });
    },
    formatServices: function(lista) {
      let toReturn = lista.map((i) => ({
        value: i.id,
        text: i.nombre,
      }));
      toReturn.unshift({
        value: null,
        text: "- Selecciona una opción -",
      });

      return toReturn;
    },
    serviceListSuperAdmin: async function() {
      const res = await axios.get(
        `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/`,
        {
          headers: {
            Authorization: `JWT ${localStorage.getItem("userToken")}`,
          },
        }
      );
      this.listServices = this.formatServices(res.data);
    },
    servicesList: async function() {
      try {
        if (this.relacionUS.rolId === 6) {
          const res = await axios.get(
            `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${this.relacionUS.ministerio.id}`
          );
          this.listServices = this.formatServices(res.data.servicios);
        } else if (this.relacionUS.rolId === 4 || this.relacionUS.rolId === 3) {
          this.listServices = this.formatServices(
            this.usuario.servicios.filter((s) => s.rolId !== 5)
          );
        }
      } catch (error) {
        console.log(error.response);
      }
    },

    closeModal: function() {
      this.showServiceModal = false;
      this.showPermsModal = false;
      this.showEditServicesModal = false;
    },
  },
  watch: {
    data: function() {
      this.usersList = this.data;
      this.showListUsers = true;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) {
        this.serviceListSuperAdmin();
        this.profileListSuperAdmin();
      } else {
        this.servicesList();
        this.profileList();
      }
    }, 200);
  },
};
</script>

<style scoped>
.actions-btn {
  border-radius: 50px;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.add {
  background: #4f52ff;
  font-size: 22px;
}
.remove {
  background: #ff4f4f;
  font-size: 22px;
}
.edit {
  background: #24c6ab;
  font-size: 17px;
}
.actions-btn:hover {
  background: #052333;
}
.acciones {
  display: flex;
  justify-content: space-evenly;
}
.bx-trash {
  font-size: 17px;
}

@media screen and (max-width: 680px) {
  .actions-btn {
    /* width: 30px !important; */
    font-size: 15px !important;
  }
}
@media screen and (max-width: 320px) {
  .btn-secondary {
    width: 25px !important;
    font-size: 8px !important;
  }
}

@media screen and (max-width: 373px) {
  .actions-btn {
    /* width: 10px !important; */
    font-size: 10px !important;
  }
}
</style>
